import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import searchIcon from '../assets/icons/searchIcon.svg'
import PropertyCard from '../components/PropertyCard';
import { motion } from "motion/react"
import useProperties from '../utils/useProperties';
import { useNavigate } from 'react-router-dom';



const Properties = () => {
    const { loading, properties } = useProperties()

    const { type } = useParams(); // Assuming the parameter is named 'type'
    const [typeFilter, setTypeFilter] = useState(type || ''); // Use URL param if available
    const [locationFilter, setLocationFilter] = useState('');
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [bedroomsFilter, setBedroomsFilter] = useState('');
    const [bathroomsFilter, setBathroomsFilter] = useState('');
    const [activeTab, setActiveTab] = useState("sale");
    const navigate = useNavigate();
    // Update filter states based on URL params
    useEffect(() => {
        if (type) {
            setTypeFilter(type);
        }
    }, [type]);

    const filteredProperties = properties?.filter((property) => {
        return (
            (typeFilter === '' || property.category === typeFilter) &&
            (locationFilter === '' || property.location.toLowerCase().includes(locationFilter.toLowerCase())) &&
            (minPrice === '' || Number(property.price) >= Number(minPrice)) &&
            (maxPrice === '' || Number(property.price) <= Number(maxPrice)) &&
            (bedroomsFilter === '' || Number(property.bed) === parseInt(bedroomsFilter)) &&
            (bathroomsFilter === '' || Number(property.bath) === parseInt(bathroomsFilter))
        );
    });
    return (
        <div>
            <div className='relative'>
                <div className="bg-gray-50 h-[70vh]">
                    <div className="z-10 absolute inset-0 bg-black bg-opacity-40"></div>
                    <img src={require('../assets/imgs/propertybg.jpeg')} alt='hero section background' className='block w-full h-full object-cover' />
                </div>
                <div className='top-[150px] md:top-[90%] left-1/2 z-20 absolute flex flex-col items-center gap-[60px] w-[90%] -translate-x-1/2 md:-translate-y-1/2 md:transform'>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
                        whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
                        transition={{ duration: 0.7, ease: "easeOut" }}
                        className='flex flex-col gap-5 m-auto px-7 lg:w-1/2 text-white'>
                        <h1 className='font-[PlayfairDisplay] font-semibold text-[40px] md:text-[60px] text-center'>Top Real Estate</h1>
                    </motion.div>
                    

                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, }}
                        whileInView={{ opacity: 1, scale: 1, }}
                        transition={{ duration: 0.7, ease: "easeOut" }}
                        className="bg-white shadow-lg mb-8 p-4 md:p-6 rounded-lg">
                        <h2 className="mb-4 font-semibold text-gray-700 text-xl">Filter Properties</h2>
                        <div className="md:flex gap-4 grid grid-cols-2">

                            {/* Property Type Filter */}
                            <div>
                                <label htmlFor="typeFilter" className="block mb-2 text-gray-600">Property Type</label>
                                <select
                                    id="typeFilter"
                                    className="shadow-sm border-gray-300 focus:border-indigo-500 rounded-lg w-full"
                                    value={typeFilter}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setTypeFilter(selectedValue);
                                        navigate(`/properties/${selectedValue}`);
                                    }}
                                >
                                    <option value="">All Types</option>
                                    <option value="Property">Property</option>
                                    <option value="Land">Land</option>
                                    <option value="Rental">Rental</option>
                                    <option value="Shortlets">Shortlets</option>
                                    <option value="Sold Properties">Sold Properties</option>
                                </select>
                            </div>

                            {/* Location Filter */}
                            <div>
                                <label htmlFor="locationFilter" className="block mb-2 text-gray-600">Location</label>
                                <select
                                    id="locationFilter"
                                    className="shadow-sm border-gray-300 focus:border-indigo-500 rounded-lg w-full"
                                    value={locationFilter}
                                    onChange={(e) => setLocationFilter(e.target.value)}
                                >
                                    <option value="">All Locations</option>
                                    <option value="Ajah">Ajah</option>
                                    <option value="Lekki">Lekki</option>
                                    <option value="Osapa">Osapa</option>
                                </select>
                            </div>

                            {/* Max Price Filter */}
                            <div>
                                <label htmlFor="minPrice" className="block mb-2 text-gray-600">Min Price (₦)</label>
                                <input
                                    type="number"
                                    id="minPrice"
                                    className="shadow-sm border-gray-300 focus:border-indigo-500 rounded-lg w-full"
                                    placeholder="Enter min price"
                                    value={minPrice}
                                    onChange={(e) => setMinPrice(e.target.value)}
                                />
                            </div>
                            <div>
                                <label htmlFor="maxPrice" className="block mb-2 text-gray-600">Max Price (₦)</label>
                                <input
                                    type="number"
                                    id="maxPrice"
                                    className="shadow-sm border-gray-300 focus:border-indigo-500 rounded-lg w-full"
                                    placeholder="Enter max price"
                                    value={maxPrice}
                                    onChange={(e) => setMaxPrice(e.target.value)}
                                />
                            </div>

                            

                            {/* Bedrooms Filter */}
                            <div>
                                <label htmlFor="bedroomsFilter" className="block mb-2 text-gray-600">Bedrooms</label>
                                <input
                                    type="number"
                                    id="bedroomsFilter"
                                    className="shadow-sm border-gray-300 focus:border-indigo-500 rounded-lg w-full"
                                    placeholder="No. of bedrooms"
                                    value={bedroomsFilter}
                                    onChange={(e) => setBedroomsFilter(e.target.value)}
                                />
                            </div>

                            {/* Bathrooms Filter */}
                            <div>
                                <label htmlFor="bathroomsFilter" className="block mb-2 text-gray-600">Bathrooms</label>
                                <input
                                    type="number"
                                    id="bathroomsFilter"
                                    className="shadow-sm border-gray-300 focus:border-indigo-500 rounded-lg w-full"
                                    placeholder="No. of bathrooms"
                                    value={bathroomsFilter}
                                    onChange={(e) => setBathroomsFilter(e.target.value)}
                                />
                            </div>

                        </div>
                    </motion.div>
                </div>
            </div>
            <div className="mx-auto mt-[40px] md:mt-[100px] max-w-7xl">

                {/* Filter Section */}


                {/* Properties List */}
                {filteredProperties ?
                    filteredProperties.length > 0 ? (
                        <div className="gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                            {filteredProperties?.map((property, index) => (
                                <Link to={`/properties/${property.category}/${property.id}`}>
                                    <PropertyCard
                                        title={property.name}
                                        price={Number(property.price).toLocaleString()}
                                        imageUrl={`https://akjodem.com/${property.imgs?.[0]}`}
                                        bedrooms={property.bed}
                                        bathrooms={property.bath}
                                        area={property.sqft}
                                        location={property.location}
                                        desc={property.description}
                                        index={index}
                                        sold={property.sold}
                                        featured={property.featured}
                                    />
                                </Link>
                            ))}
                        </div>
                    ) : (
                        <div className="col-span-full text-gray-900 text-2xl text-center">
                            No items found matching the filters.
                        </div>
                    ) : <div className="col-span-full text-gray-900 text-2xl text-center">
                        No items found.
                    </div>}
            </div>
        </div>
    );
};

export default Properties;
